import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Inject, OnInit, Output } from '@angular/core';

import { formatString } from '@frontend/sports/common/core/utils/string';

import { IBetslipMessages } from '../../../base/models/betslip-messages';
import { BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN, IBetslipMessagesProviderService } from '../../../base/services/betslip-messages-provider.service';

@Component({
    selector: 'bs-user-stake-limit-info',
    templateUrl: './user-stake-limit-info.html',
    styleUrls: ['./user-stake-limit-info.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class UserStakeLimitsInfoComponent implements OnInit {
    @Output() close = new EventEmitter<boolean>();
    @HostBinding('class') className = 'betslip-taxation-info user-stake-limit-info';

    helpTextWithUrl: string;
    messages: IBetslipMessages;

    constructor(@Inject(BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN) messagesProvider: IBetslipMessagesProviderService) {
        this.messages = messagesProvider.getMessages();
    }

    ngOnInit(): void {
        const helpText = this.messages.common.MonthlyStakeHelpUrl;
        this.helpTextWithUrl = formatString(helpText, this.messages.editBet.bwinHelpPage);
    }

    okClick(): void {
        this.close.emit();
    }
}
